"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.seriesOptions = exports.legendOption = exports.getYAxisOptions = exports.getXAxisOptions = exports.getTooltipOptions = exports.getScrollbarOptions = exports.getResponsiveOptions = exports.getRangeSelectorOptions = exports.getPlotOptions = exports.getNavigatorOptions = exports.getChartOptions = void 0;
const highcharts_1 = __importDefault(require("highcharts/highcharts"));
const colors_1 = require("../../../assets/styles/colors");
const fixedStreamSlice_1 = require("../../../store/fixedStreamSlice");
const mapSlice_1 = require("../../../store/mapSlice");
const mobileStreamSlice_1 = require("../../../store/mobileStreamSlice");
const timeRanges_1 = require("../../../utils/timeRanges");
const updateRangeDisplay_1 = require("./chartHooks/updateRangeDisplay");
const getScrollbarOptions = (isCalendarPage, isMobile) => {
    return {
        barBackgroundColor: colors_1.gray200,
        barBorderWidth: 0,
        button: {
            enabled: false,
        },
        height: isMobile ? 16 : 8,
        trackBackgroundColor: colors_1.gray100,
        trackBorderWidth: 0,
        autoHide: false,
        showFull: true,
        enabled: isMobile && isCalendarPage ? true : !isMobile,
        liveRedraw: true,
        minWidth: isMobile ? 30 : 8,
        rifleColor: colors_1.gray200,
        zIndex: 3,
        margin: 0,
        minimumRange: timeRanges_1.MILLISECONDS_IN_A_SECOND,
    };
};
exports.getScrollbarOptions = getScrollbarOptions;
const getXAxisOptions = (isMobile, fixedSessionTypeSelected, dispatch, fetchMeasurementsIfNeeded, streamId, lastTriggerRef, lastUpdateTimeRef, onDayClick, rangeDisplayRef, sessionStartTime, sessionEndTime, isCalendarDaySelectedRef, setOverrideRangeSelector) => {
    let lastNavigatorEvent = null;
    let navigatorMouseUpHandler = null;
    let touchEndHandler = null;
    let cleanupTimeout = null;
    let handled = false;
    let isHandlingCalendarDay = false;
    let mouseWheelTimeout = null;
    let lastMouseWheelEvent = null;
    const removeEventHandlers = () => {
        if (navigatorMouseUpHandler) {
            window.removeEventListener("mouseup", navigatorMouseUpHandler, true);
            navigatorMouseUpHandler = null;
        }
        if (touchEndHandler) {
            window.removeEventListener("touchend", touchEndHandler, true);
            touchEndHandler = null;
        }
        if (cleanupTimeout) {
            clearTimeout(cleanupTimeout);
            cleanupTimeout = null;
        }
        lastNavigatorEvent = null;
    };
    const handleSetExtremes = (e, chart) => __awaiter(void 0, void 0, void 0, function* () {
        const effectiveTrigger = e.trigger !== "none" ? e.trigger : lastTriggerRef.current || "none";
        if (isHandlingCalendarDay && effectiveTrigger !== "calendarDay")
            return;
        if (effectiveTrigger === "calendarDay") {
            isHandlingCalendarDay = true;
            setTimeout(() => {
                isHandlingCalendarDay = false;
            }, 500);
            lastTriggerRef.current = effectiveTrigger;
            lastUpdateTimeRef.current = Date.now();
            if (e.min !== undefined &&
                e.max !== undefined &&
                !isNaN(e.min) &&
                !isNaN(e.max)) {
                (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, e.min, e.max, true);
                // Update measurement extremes whenever extremes change
                if (streamId) {
                    if (fixedSessionTypeSelected) {
                        dispatch((0, fixedStreamSlice_1.updateFixedMeasurementExtremes)({
                            streamId,
                            min: e.min,
                            max: e.max,
                        }));
                    }
                    else {
                        dispatch((0, mobileStreamSlice_1.updateMobileMeasurementExtremes)({
                            min: e.min,
                            max: e.max,
                        }));
                    }
                }
            }
            return;
        }
        if (effectiveTrigger === "mousewheel") {
            setOverrideRangeSelector(true);
            lastMouseWheelEvent = e;
            const rangeSelector = chart.rangeSelector;
            if (rangeSelector === null || rangeSelector === void 0 ? void 0 : rangeSelector.buttons) {
                rangeSelector.buttons.forEach((button) => button.setState(0));
                rangeSelector.selected = undefined;
            }
            if (isCalendarDaySelectedRef === null || isCalendarDaySelectedRef === void 0 ? void 0 : isCalendarDaySelectedRef.current) {
                isCalendarDaySelectedRef.current = false;
                if (onDayClick)
                    onDayClick(null);
            }
            lastTriggerRef.current = effectiveTrigger;
            lastUpdateTimeRef.current = Date.now();
            if (e.min !== undefined &&
                e.max !== undefined &&
                !isNaN(e.min) &&
                !isNaN(e.max)) {
                (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, e.min, e.max, false);
                if (streamId) {
                    if (fixedSessionTypeSelected) {
                        dispatch((0, fixedStreamSlice_1.updateFixedMeasurementExtremes)({
                            streamId,
                            min: e.min,
                            max: e.max,
                        }));
                    }
                    else {
                        dispatch((0, mobileStreamSlice_1.updateMobileMeasurementExtremes)({
                            min: e.min,
                            max: e.max,
                        }));
                    }
                }
            }
            if (mouseWheelTimeout)
                clearTimeout(mouseWheelTimeout);
            mouseWheelTimeout = setTimeout(() => {
                if (lastMouseWheelEvent && streamId) {
                    const visibleRange = lastMouseWheelEvent.max - lastMouseWheelEvent.min;
                    const padding = visibleRange * 0.25;
                    const now = Date.now();
                    const fetchStart = Math.max(sessionStartTime || 0, lastMouseWheelEvent.min - padding);
                    const fetchEnd = Math.min(sessionEndTime || now, lastMouseWheelEvent.max + padding);
                    fetchMeasurementsIfNeeded(fetchStart, fetchEnd, false, false, "mousewheel").finally(() => {
                        chart.hideLoading();
                    });
                }
                else {
                    chart.hideLoading();
                }
                setOverrideRangeSelector(false);
                mouseWheelTimeout = null;
                lastMouseWheelEvent = null;
            }, 1000);
            return;
        }
        if (effectiveTrigger === "pan" ||
            effectiveTrigger === "zoom" ||
            effectiveTrigger === "rangeSelectorButton") {
            if (e.min !== undefined &&
                e.max !== undefined &&
                !isNaN(e.min) &&
                !isNaN(e.max)) {
                (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, e.min, e.max, false);
                if (streamId) {
                    if (fixedSessionTypeSelected) {
                        dispatch((0, fixedStreamSlice_1.updateFixedMeasurementExtremes)({
                            streamId,
                            min: e.min,
                            max: e.max,
                        }));
                    }
                    else {
                        dispatch((0, mobileStreamSlice_1.updateMobileMeasurementExtremes)({
                            min: e.min,
                            max: e.max,
                        }));
                    }
                }
            }
        }
        lastTriggerRef.current = effectiveTrigger;
        lastUpdateTimeRef.current = Date.now();
        if (e.min !== undefined &&
            e.max !== undefined &&
            !isNaN(e.min) &&
            !isNaN(e.max)) {
            (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, e.min, e.max, effectiveTrigger === "calendarDay");
        }
        if (streamId &&
            (effectiveTrigger === "rangeSelectorButton" ||
                effectiveTrigger === "pan" ||
                effectiveTrigger === "zoom" ||
                effectiveTrigger === "calendarDay" ||
                effectiveTrigger === "syncExtremes" ||
                effectiveTrigger === "navigator")) {
            const visibleRange = e.max - e.min;
            const padding = visibleRange * 0.25;
            const now = Date.now();
            const fetchStart = Math.max(sessionStartTime || 0, e.min - padding);
            const fetchEnd = Math.min(sessionEndTime || now, e.max + padding);
            if (fixedSessionTypeSelected) {
                yield fetchMeasurementsIfNeeded(fetchStart, fetchEnd, false, false, effectiveTrigger);
            }
        }
    });
    return {
        title: { text: undefined },
        showEmpty: false,
        showLastLabel: !isMobile,
        tickColor: colors_1.gray200,
        lineColor: colors_1.white,
        type: "datetime",
        labels: {
            enabled: true,
            overflow: "justify",
            step: 1,
            style: { fontSize: "1.2rem", fontFamily: "Roboto" },
        },
        crosshair: { color: colors_1.white, width: 2 },
        visible: true,
        minRange: timeRanges_1.MILLISECONDS_IN_A_SECOND,
        ordinal: false,
        min: fixedSessionTypeSelected ? sessionStartTime : null,
        max: fixedSessionTypeSelected ? sessionEndTime : null,
        events: {
            afterSetExtremes: function (e) {
                const chart = this.chart;
                const effectiveTrigger = e.trigger !== "none" ? e.trigger : lastTriggerRef.current || "none";
                if (isHandlingCalendarDay && effectiveTrigger !== "calendarDay")
                    return;
                const rangeSelector = chart.rangeSelector;
                if (effectiveTrigger === "mousewheel" && (rangeSelector === null || rangeSelector === void 0 ? void 0 : rangeSelector.buttons)) {
                    rangeSelector.buttons.forEach((button) => button.setState(0));
                }
                if (effectiveTrigger !== "navigator") {
                    removeEventHandlers();
                    handleSetExtremes(Object.assign(Object.assign({}, e), { trigger: effectiveTrigger }), chart);
                    return;
                }
                lastNavigatorEvent = e;
                lastTriggerRef.current = "navigator";
                if (!navigatorMouseUpHandler && !touchEndHandler) {
                    handled = false;
                    const handleEnd = () => {
                        if (handled)
                            return;
                        handled = true;
                        if (lastNavigatorEvent && !isHandlingCalendarDay) {
                            handleSetExtremes(lastNavigatorEvent, chart);
                        }
                        removeEventHandlers();
                    };
                    removeEventHandlers();
                    navigatorMouseUpHandler = handleEnd;
                    touchEndHandler = handleEnd;
                    window.addEventListener("mouseup", navigatorMouseUpHandler, true);
                    window.addEventListener("touchend", touchEndHandler, true);
                    cleanupTimeout = setTimeout(() => {
                        handleEnd();
                    }, 8000);
                }
            },
        },
    };
};
exports.getXAxisOptions = getXAxisOptions;
const getYAxisOptions = (thresholdsState, isMobile = false) => {
    const min = Math.floor(Number(thresholdsState.min));
    const max = Math.ceil(Number(thresholdsState.max));
    const low = Math.round(Number(thresholdsState.low));
    const middle = Math.round(Number(thresholdsState.middle));
    const high = Math.round(Number(thresholdsState.high));
    return {
        title: {
            text: undefined,
        },
        endOnTick: false,
        startOnTick: true,
        tickColor: colors_1.gray200,
        lineColor: colors_1.white,
        opposite: true,
        tickWidth: 1,
        tickLength: isMobile ? 0 : 25,
        minorGridLineWidth: 0,
        showLastLabel: true,
        tickPosition: "inside",
        offset: isMobile ? 0 : 25,
        labels: {
            enabled: true,
            style: {
                fontFamily: "Roboto",
                fontSize: "1.2rem",
                align: "right",
            },
        },
        gridLineWidth: 0,
        minPadding: 0,
        min: min,
        max: max,
        tickPositions: [min, low, middle, high, max],
        plotBands: [
            {
                from: min,
                to: low,
                color: colors_1.green100,
            },
            {
                from: low,
                to: middle,
                color: colors_1.yellow100,
            },
            {
                from: middle,
                to: high,
                color: colors_1.orange100,
            },
            {
                from: high,
                to: max,
                color: colors_1.red100,
            },
        ],
    };
};
exports.getYAxisOptions = getYAxisOptions;
const getPlotOptions = (fixedSessionTypeSelected, streamId, dispatch, isIndoorParameterInUrl, isGovData) => {
    const handleMouseOver = function () {
        if (!isIndoorParameterInUrl) {
            const position = this.position;
            if (fixedSessionTypeSelected) {
                dispatch((0, mapSlice_1.setHoverStreamId)(streamId));
            }
            else {
                dispatch((0, mapSlice_1.setHoverPosition)(position));
            }
        }
    };
    const handleMouseOut = () => {
        if (!isIndoorParameterInUrl) {
            dispatch((0, mapSlice_1.setHoverStreamId)(null));
            dispatch((0, mapSlice_1.setHoverPosition)({ lat: 0, lng: 0 }));
        }
    };
    return {
        series: {
            lineWidth: 2,
            color: colors_1.blue,
            turboThreshold: 9999999,
            marker: {
                fillColor: colors_1.blue,
                lineWidth: 0,
                lineColor: colors_1.blue,
                radius: 3,
            },
            states: {
                hover: {
                    halo: {
                        attributes: {
                            fill: colors_1.blue,
                            "stroke-width": 2,
                        },
                    },
                },
            },
            dataGrouping: {
                enabled: true,
                units: isGovData
                    ? [
                        ["hour", [1, 2, 3, 4, 6, 8, 12]],
                        ["day", [1]],
                    ]
                    : [
                        ["millisecond", []],
                        ["second", [2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30, 40, 50]],
                        ["minute", [1, 2, 3, 4, 5]],
                    ],
                approximation: "average",
            },
            point: {
                events: {
                    mouseOver: handleMouseOver,
                    mouseOut: handleMouseOut,
                },
            },
        },
    };
};
exports.getPlotOptions = getPlotOptions;
const seriesOptions = (data) => ({
    type: "spline",
    color: colors_1.white,
    data: data,
});
exports.seriesOptions = seriesOptions;
const legendOption = {
    enabled: false,
};
exports.legendOption = legendOption;
const getResponsiveOptions = (thresholdsState, isMobile) => {
    return {
        rules: [
            {
                condition: {
                    maxWidth: 1024,
                },
                chartOptions: {
                    yAxis: getYAxisOptions(thresholdsState, isMobile),
                    credits: {
                        enabled: false,
                    },
                },
            },
        ],
    };
};
exports.getResponsiveOptions = getResponsiveOptions;
const getTooltipOptions = (measurementType, unitSymbol) => ({
    enabled: true,
    formatter: function () {
        const dateStr = highcharts_1.default.dateFormat("%m/%d/%Y", Number(this.x));
        let s = `<span>${dateStr} `;
        const pointData = this.points ? this.points[0] : this.point;
        const point = pointData;
        const series = point.series;
        if (series.hasGroupedData && series.currentDataGrouping) {
            if (series.currentDataGrouping.count === 1) {
                s += highcharts_1.default.dateFormat("%H:%M:%S", point.x) + "</span>";
            }
            else {
                const groupingInfo = series.currentDataGrouping;
                const groupingDiff = groupingInfo.totalRange;
                const xLess = point.x;
                const xMore = point.x + groupingDiff;
                s += highcharts_1.default.dateFormat("%H:%M:%S", xLess) + "-";
                s += highcharts_1.default.dateFormat("%H:%M:%S", xMore - 1000) + "</span>";
            }
        }
        else {
            s += highcharts_1.default.dateFormat("%H:%M:%S", point.x) + "</span>";
        }
        s +=
            "<br/>" +
                measurementType +
                " = " +
                Math.round(pointData.y || 0) +
                " " +
                unitSymbol;
        return s;
    },
    borderWidth: 0,
    style: {
        fontSize: "1.2rem",
        fontFamily: "Roboto",
    },
});
exports.getTooltipOptions = getTooltipOptions;
const getRangeSelectorOptions = (isMobile, fixedSessionTypeSelected, totalDuration, selectedRange, isCalendarPage, t) => {
    const baseMobileCalendarOptions = {
        enabled: true,
        buttonPosition: {
            align: "center",
            y: -85,
        },
        buttonTheme: {
            fill: "none",
            width: 80,
            height: 34,
            r: 20,
            stroke: "none",
            "stroke-width": 1,
            style: {
                fontFamily: "Roboto, sans-serif",
                fontSize: "1.4rem",
                color: colors_1.gray300,
                fontWeight: "regular",
            },
            states: {
                hover: {
                    fill: colors_1.blue,
                    style: {
                        color: colors_1.white,
                    },
                },
                select: {
                    fill: colors_1.blue,
                    style: {
                        color: colors_1.white,
                        fontWeight: "bold",
                    },
                },
                disabled: {
                    style: {
                        color: colors_1.disabledGraphButton,
                        cursor: "default",
                    },
                },
            },
        },
        labelStyle: {
            display: "none",
        },
        buttonSpacing: 10,
        inputEnabled: false,
    };
    const baseOptions = {
        enabled: isMobile ? false : true,
        buttonPosition: {
            align: "right",
            x: -32,
            y: 50,
        },
        buttonTheme: {
            fill: "rgba(255, 255, 255, 0.8)",
            width: 90,
            r: 5,
            style: {
                fontFamily: "Roboto, sans-serif",
                fontSize: "1.4rem",
                color: colors_1.gray300,
                fontWeight: "regular",
            },
            states: {
                hover: {
                    fill: colors_1.white,
                    style: {
                        color: colors_1.gray400,
                        fontWeight: "regular",
                    },
                },
                select: {
                    fill: colors_1.white,
                    style: {
                        color: colors_1.gray400,
                        fontWeight: "regular",
                    },
                },
            },
        },
        labelStyle: {
            display: "none",
        },
        buttonSpacing: 10,
        inputEnabled: false,
    };
    if (isCalendarPage && isMobile) {
        return Object.assign(Object.assign({}, baseMobileCalendarOptions), { buttons: [
                { type: "hour", count: 24, text: t("graph.24Hours") },
                totalDuration > timeRanges_1.MILLISECONDS_IN_A_WEEK
                    ? { type: "day", count: 7, text: t("graph.oneWeek") }
                    : { type: "all", text: t("graph.oneWeek") },
                totalDuration > timeRanges_1.MILLISECONDS_IN_A_MONTH
                    ? { type: "week", count: 4, text: t("graph.oneMonth") }
                    : { type: "all", text: t("graph.oneMonth") },
            ], allButtonsEnabled: true, selected: selectedRange });
    }
    else {
        if (fixedSessionTypeSelected) {
            return Object.assign(Object.assign({}, baseOptions), { buttons: [
                    totalDuration < timeRanges_1.MILLISECONDS_IN_A_DAY
                        ? { type: "all", text: t("graph.24Hours") }
                        : { type: "hour", count: 24 - 0, text: t("graph.24Hours") },
                    totalDuration > timeRanges_1.MILLISECONDS_IN_A_WEEK
                        ? { type: "day", count: 7, text: t("graph.oneWeek") }
                        : { type: "all", text: t("graph.oneWeek") },
                    totalDuration > timeRanges_1.MILLISECONDS_IN_A_MONTH
                        ? { type: "week", count: 4, text: t("graph.oneMonth") }
                        : { type: "all", text: t("graph.oneMonth") },
                ], allButtonsEnabled: true, selected: selectedRange });
        }
        else {
            return Object.assign(Object.assign({}, baseOptions), { buttons: [
                    totalDuration < timeRanges_1.MILLISECONDS_IN_A_5_MINUTES
                        ? { type: "all", text: t("graph.fiveMinutes") }
                        : { type: "minute", count: 5, text: t("graph.fiveMinutes") },
                    totalDuration < timeRanges_1.MILLISECONDS_IN_AN_HOUR
                        ? { type: "all", text: t("graph.oneHour") }
                        : { type: "minute", count: 60, text: t("graph.oneHour") },
                    { type: "all", text: t("graph.all") },
                ], allButtonsEnabled: true, selected: selectedRange });
        }
    }
};
exports.getRangeSelectorOptions = getRangeSelectorOptions;
const getChartOptions = (isCalendarPage, isMobile) => {
    const zoomingConfig = {
        type: "x",
        resetButton: { theme: { style: { display: "none" } } },
    };
    const chartHeight = isCalendarPage || !isMobile ? 300 : 150;
    const chartMargin = isMobile
        ? isCalendarPage
            ? [5, 10, 5, 0]
            : [5, 0, 5, 0]
        : isCalendarPage
            ? [0, 30, 5, 0]
            : [0, 60, 5, 0];
    const scrollablePlotAreaConfig = { minWidth: 100, scrollPositionX: 1 };
    return {
        zooming: zoomingConfig,
        height: chartHeight,
        margin: chartMargin,
        animation: false,
        scrollablePlotArea: scrollablePlotAreaConfig,
    };
};
exports.getChartOptions = getChartOptions;
const getNavigatorOptions = () => {
    return {
        enabled: true,
        height: 0,
    };
};
exports.getNavigatorOptions = getNavigatorOptions;
